import React from 'react';
import { useState } from 'react';
export function QuantitySelect({ onChange }) {
    const [count, updateQuantity] = useState(1);
    const decrement = () => {
        let currentCount = count > 1 ? count - 1 : 1;
        updateQuantity(currentCount);
        onChange(currentCount);
    };
    const increment = () => {
        let currentCount = count + 1;
        updateQuantity(currentCount);
        onChange(currentCount);
    };
    return (React.createElement("div", { className: "tailwind" },
        React.createElement("div", { className: "quantity-wrapper flex flex-row justify-between items-center lg:mb-4" },
            React.createElement("div", { className: "qty-buttons-wrapper flex flex-row items-center" },
                React.createElement("span", { className: "cursor qty-button minus flex justify-center items-center text-lg text-dark-gray h-8 w-8 pr-4", onClick: decrement },
                    React.createElement("i", { className: "vp-icon-minus-light" })),
                React.createElement("input", { type: "number", className: "qty-number font-sans text-lg py-2 font-bold block w-24 text-center text-dark-gray", id: "qty-number", name: "quantity", value: count, style: { border: '1px solid #C6D2D4', MozAppearance: 'textfield' }, readOnly: true }),
                React.createElement("span", { className: "cursor qty-button plus flex justify-center items-center text-dark-gray h-8 w-8 pl-4", onClick: increment },
                    React.createElement("i", { className: "vp-icon-plus-light" }))))));
}
